import React from "react";
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, PaperClipOutlined } from "@ant-design/icons";
import moment from "moment";
import { ListGroup } from "react-bootstrap";

export const ObavijestTemplateView = ({ obavijest, index, status, className, props }) => {
	function render() {
		if (obavijest.sts === status) {
			return (
				<ListGroup key={`unos-obavijesti${index}`} horizontal className={className}>
					<ListGroup.Item key={obavijest.idStrUsv}>
						<DateDisplay start={obavijest.absenceStart} end={obavijest.absenceEnd} />
						<DocumentsDisplay documents={obavijest.dokumenti} handleDownload={props.downloadObavijest} />
						<NoteDisplay note={obavijest.napomena} />
					</ListGroup.Item>
                    
                    {obavijest.sts === 1 &&
                        <DeleteActionDisplay documents={obavijest.dokumenti} actionHandler={props.deleteObavijestHandler}/>
                    }

					{(props.userRole === "ROLE_SLUZBENIK" && obavijest.sts === 1) && 
                        <AdminActionDisplay obavijest={obavijest} disabled={props.isListLoading} approveHandler={props.approveObavijestHandler} disapprovHandler={props.disableObavijestHandler}/>
                    }
				</ListGroup>
			);
		}
		return null;
	}

	return render();
};

const DateDisplay = ({ start, end }) => {
	return (
		<>
			{start && end && (
				<>
					<b>
						{moment(start).format("DD.MM.YYYY.")}- {moment(end).format("DD.MM.YYYY.")}
					</b>
					<br />
				</>
			)}
		</>
	);
};

const DocumentsDisplay = ({ documents, handleDownload }) => {
	return (
		<>
			{documents.map((document) => (
				<a onClick={(e) => handleDownload(e, document.dokumentId)} title={document.name} key={document.dokumentId}>
					<div className="download-link-wrapper">
						<PaperClipOutlined style={{ height: "28px", marginRight: "10px" }} />
						{document.name}
					</div>
				</a>
			))}
		</>
	);
};

const NoteDisplay = ({ note }) => {
	return (
		<>
			{note ? (
				<>
					<br></br>
					NAPOMENA: <i>{note}</i>
				</>
			) : null}
		</>
	);
};

const DeleteActionDisplay = ({documents, actionHandler, isLoading}) => {
	return (
		<ListGroup.Item
			key="btn-delete"
			type="button"
			variant="danger"
			as={"button"}
			className="btn-item-delete"
			disabled={isLoading}
			onClick={() => {
				documents.forEach((dokument) => {
					actionHandler(dokument.dokumentId);
				});
			}}>
			<DeleteOutlined />
		</ListGroup.Item>
	);
};

const AdminActionDisplay = ({obavijest, disabled, index, approveHandler, disapprovHandler}) => {
    return(
        <ListGroup key={`unos-obavijesti-sluzbenik${index}`} vertical="true" className="obavijest-list-group-vertical">
            <ListGroup.Item key="btn-approve" type="button" variant="success" as={"button"} className="btn-item-approve" 
                disabled={disabled} 
                onClick={() => approveHandler(obavijest.dokumenti[0].dokumentId)}
            >
                <CheckCircleOutlined />
            </ListGroup.Item>

            <ListGroup.Item key="btn-disable" type="button" variant="warning" as={"button"} className="btn-item-disable"
                disabled={disabled}
                onClick={() => {
                    obavijest.dokumenti.forEach((dokument) => {disapprovHandler(dokument.dokumentId);});
                }}>
                <CloseCircleOutlined />
            </ListGroup.Item>
        </ListGroup>
    )
}